<template>
    <div>
        <Pane title="重新提交设计变更" :showRemarks="false">
            <template>重新发起设计变更流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 12 }">
                <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }">
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="项目名称">
                                    <a-input v-model="form.projectName" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计编号">
                                    <a-input v-model="form.designNo" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="专业编码">
                                    <a-select v-model="form.majorCode" disabled placeholder="">
                                        <a-select-option v-for="item in majorList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="通知单编号">
                                    <a-input v-model="form.serialNo" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="管理级别">
                                    <a-radio-group v-model="form.manageLevel" disabled>
                                        <a-radio-button v-for="item in manageLevelList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="附图张数">
                                    <a-input-number v-model="form.drawingCount" :min="0" style="width: 100%" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="子项名称">
                                    <a-select mode="multiple" v-model="selectedSubItems" placeholder="请选择子项" style="width: 100%">
                                        <a-select-option v-for="item in subItemList" :key="item.subCode" :value="String(item.subCode)">{{ item.subName }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="会签人">
                                    <EmployeeSelector
                                        multiple
                                        @change="handleSignerChange"
                                        :value="signerList"
                                    >
                                        <a-button block style="text-align: left">{{ signerList.length ? signerList.map(i => i.name).join(',') : '请选择会签人' }}</a-button>
                                    </EmployeeSelector>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title" style="margin-top: 0">更改信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="24">
                                <a-form-item label="更改原因" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.changeReason" :rows="3" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入更改原因" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item label="更改内容" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.changeContent" :rows="4" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入更改内容" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.remark" :rows="2" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入备注" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="附件">
                                    <Attachment :editable="true" :fileList="fileList" @change="fileList = $event" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title" style="margin-top: 0">关联成果</div>
                    <div class="wrapper">
                        <a-button type="dashed" style="width: 100%; margin-bottom: 12px;" icon="plus" @click="handleAddResult">添加成果</a-button>
                        <a-table :columns="resultColumns" :data-source="selectedResults" :pagination="false" rowKey="id" :bordered="true" size="small">
                            <template slot="action" slot-scope="text, record, index">
                                <a-button type="link" style="color: #ff4d4f" @click="handleRemoveResult(index)">删除</a-button>
                            </template>
                            <template slot="auditStatus" slot-scope="text">
                                <approve-status-tag :status="text" />
                            </template>
                        </a-table>
                    </div>

                    <a-modal :visible="addResultVisible" title="选择关联成果" @ok="handleAddResultConfirm" @cancel="addResultVisible = false" width="800px" :bodyStyle="{ maxHeight: '500px', overflow: 'auto' }" destroyOnClose>
                        <a-table :columns="selectResultColumns" :data-source="resultList" :pagination="false" @change="handleResultTableChange" :loading="resultLoading" :row-selection="{ type: 'checkbox', selectedRowKeys: selectedResultKeys, onChange: handleResultSelectChange }" rowKey="id" :scroll="{ y: 300 }" :bordered="true" size="small">
                            <template slot="auditStatus" slot-scope="text">
                                <approve-status-tag :status="text" />
                            </template>
                        </a-table>
                    </a-modal>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { fetchDesignChangeDetail, resubmitDesignChange } from '@/api/project-design/change'
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'
import EmployeeSelector from "@/components/employee-selector";
import Attachment from "@/components/attachment";
import ApproveStatusTag from "@/components/columns/ApproveStatusTag.vue";
import { fetchDesignResultList, fetchPrjTaskPhaseSummary } from '@/api/project-execute/result'
import { getDesignPlanPersonnel } from "@/api/project-design/transfer";
import { fetchSimplePlanPersonnel } from "@/api/project-plan/simple-plan";

export default {
    name: "DesignChangeReapply",
    components: { EmployeeSelector, Attachment, ApproveStatusTag },
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            phaseId: "",
            taskId: "",
            instanceId: "",
            form: {
                projectName: "",
                designNo: "",
                majorCode: "",
                serialNo: "",
                manageLevel: "",
                drawingCount: 0,
                changeReason: "",
                changeContent: "",
                remark: "",
            },
            fileList: [],
            signerList: [],
            selectedSubItems: [],
            subItemList: [],
            selectedResults: [],
            resultList: [],
            addResultVisible: false,
            selectedResultKeys: [],
            resultLoading: false,
            resultPagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: total => `共 ${total} 条`
            },
            localPlanProject: null,
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        currentPlanProject() {
            return this.localPlanProject;
        },
        majorList() {
            return (this.findDataDict && this.findDataDict("cosys.major")) || [];
        },
        manageLevelList() { return this.findDataDict('cosys.manageLevel') || [] },
        resultColumns() {
            return [
                { title: '成果名称', dataIndex: 'resultName', ellipsis: true },
                { title: '成果编号', dataIndex: 'resultNo', width: 120 },
                { title: '审核状态', dataIndex: 'auditStatus', width: 100, scopedSlots: { customRender: 'auditStatus' } },
                { title: '提交人', dataIndex: 'submitUserName', width: 100 },
                { title: '提交日期', dataIndex: 'createAt', width: 120 },
                { title: '操作', key: 'action', width: 80, scopedSlots: { customRender: 'action' } }
            ]
        },
        selectResultColumns() {
            return [
                { title: '成果名称', dataIndex: 'resultName', ellipsis: true },
                { title: '成果编号', dataIndex: 'resultNo', width: 120 },
                { title: '审核状态', dataIndex: 'auditStatus', width: 100, scopedSlots: { customRender: 'auditStatus' } },
                { title: '提交人', dataIndex: 'submitUserName', width: 100 },
                { title: '提交日期', dataIndex: 'createAt', width: 120 },
            ]
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }

        this.fetchDetail();
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        async fetchDetail() {
            if (!this.id) {
                this.loading = false;
                return;
            }
            this.loading = true;
            try {
                const data = await fetchDesignChangeDetail(this.id);
                if (!data) return;
                this.phaseId = data.phaseId || "";
                if (this.phaseId) {
                    try {
                        const summary = await fetchPrjTaskPhaseSummary(this.phaseId);
                        if (summary) {
                            const projectCode = data.designNo || '';
                            const prjNo = projectCode.split('-')[0] || '';
                            this.localPlanProject = {
                                id: summary.id,
                                phaseId: summary.id,
                                code: projectCode,
                                name: summary.name,
                                prjNo: prjNo,
                                prjName: summary.name,
                                phaseCode: summary.phaseCode,
                                phaseName: summary.phaseName,
                                manageLevel: summary.manageLevel,
                                prjCategory: summary.prjCategory,
                                designCode: summary.designCode,
                                customerName: summary.customerName,
                                mainDeptName: summary.mainDeptName,
                                majors: summary.majors || '',
                                noticeId: null,
                                requireFinishDate: summary.planEndDate || null,
                                planPrjLeaderId: null,
                                planPrjLeaderName: null,
                                mainDeptId: null,
                                createAt: null,
                            };
                        }
                    } catch (e) {
                        console.warn('fetchPrjTaskPhaseSummary failed', e);
                    }
                }
                this.form = {
                    projectName: data.projectName || "",
                    designNo: data.designNo || "",
                    majorCode: data.majorCode || "",
                    serialNo: data.serialNo || "",
                    manageLevel: data.manageLevel || "",
                    drawingCount: data.drawingCount ?? 0,
                    changeReason: data.changeReason || "",
                    changeContent: data.changeContent || "",
                    remark: data.remark || "",
                };
                if (data.signerIds && data.signerNames) {
                    const ids = data.signerIds.split(',').filter(Boolean);
                    const names = data.signerNames.split(',').filter(Boolean);
                    this.signerList = ids.map((id, index) => ({ id, name: names[index] || '' }));
                }
                if (data.subCodes && data.subNames) {
                    const codes = data.subCodes.split(',').filter(Boolean);
                    const names = data.subNames.split(',').filter(Boolean);
                    this.selectedSubItems = codes;
                    this.subItemList = codes.map((code, i) => ({ subCode: code, subName: names[i] || code }));
                }
                this.fileList = parseAttachment(data.attachment, data.attachmentPaths);
                if (data.designResults && Array.isArray(data.designResults)) {
                    this.selectedResults = data.designResults
                } else if (data.designResultIds) {
                    const ids = data.designResultIds.split(',').filter(Boolean)
                    this.selectedResults = ids.map(id => ({ id }))
                }
                await this.loadPersonnel();
                if (data.subCodes) {
                    this.selectedSubItems = data.subCodes.split(',').filter(Boolean);
                }
            } finally {
                this.loading = false;
            }
        },
        async loadPersonnel() {
            const currentMajor = this.form.majorCode;
            const phaseId = this.phaseId;
            if (!currentMajor || !phaseId) return;
            try {
                const planProject = this.currentPlanProject;
                const isSimple = planProject?.prjCategory === 'simple';
                const res = isSimple
                    ? await fetchSimplePlanPersonnel({ majorCode: currentMajor, phaseId })
                    : await getDesignPlanPersonnel({ majorCode: currentMajor, phaseId });
                if (!res) return;
                if (res.subItemPersonnels && res.subItemPersonnels.length) {
                    this.subItemList = res.subItemPersonnels;
                }
            } catch (e) {
                console.error('获取设计计划人员配置失败', e);
            }
        },
        handleSignerChange(arr) {
            this.signerList = arr;
        },
        handleAddResult() {
            if (!this.form.majorCode) {
                this.$message.warning('请先选择专业');
                return;
            }
            this.addResultVisible = true
            this.selectedResultKeys = this.selectedResults.map(r => r.id)
            this.resultPagination.current = 1
            this.fetchResultList()
        },
        async fetchResultList() {
            this.resultLoading = true
            try {
                const params = {
                    majorCode: this.form.majorCode,
                    phaseId: this.phaseId,
                    auditStatus: 'Pass',
                    pageNum: this.resultPagination.current,
                    pageSize: 999,
                }
                const res = await fetchDesignResultList(params)
                this.resultList = res.list || []
                this.resultPagination.total = res.totalSize || res.total || 0
            } catch (e) {
                this.resultList = []
            } finally {
                this.resultLoading = false
            }
        },
        handleResultTableChange(newPagination) {
            this.resultPagination.current = newPagination.current
            this.resultPagination.pageSize = newPagination.pageSize
            this.fetchResultList()
        },
        handleAddResultConfirm() {
            const selected = this.resultList.filter(r => this.selectedResultKeys.includes(r.id))
            const existingIds = this.selectedResults.map(r => r.id)
            const filtered = selected.filter(r => !existingIds.includes(r.id))
            this.selectedResults = [...this.selectedResults, ...filtered.map(r => ({
                id: r.id,
                resultName: r.resultName || '',
                resultNo: r.resultNo || '',
                auditStatus: r.auditStatus || '',
                submitDate: r.submitDate || '',
                submitUserName: r.submitUserName || ''
            }))]
            this.addResultVisible = false
            this.selectedResultKeys = []
        },
        handleRemoveResult(index) {
            this.selectedResults.splice(index, 1)
        },
        handleResultSelectChange(keys) {
            this.selectedResultKeys = keys
        },
        submitReview() {
            this.submitting = true;
            const { attachment, attachmentPaths } = buildAttachmentData(this.fileList);
            const data = {
                id: this.id,
                phaseId: this.phaseId,
                projectName: this.form.projectName,
                designNo: this.form.designNo,
                majorCode: this.form.majorCode,
                serialNo: this.form.serialNo,
                manageLevel: this.form.manageLevel,
                drawingCount: this.form.drawingCount,
                changeReason: this.form.changeReason,
                changeContent: this.form.changeContent,
                remark: this.form.remark,
                signerIds: this.signerList.map(s => s.userId || s.id).join(','),
                signerNames: this.signerList.map(s => s.name).join(','),
                subCodes: this.selectedSubItems.join(','),
                subNames: this.selectedSubItems.map(code => {
                    const item = this.subItemList.find(i => String(i.subCode) === code);
                    return item ? item.subName : code;
                }).join(','),
                designResultIds: this.selectedResults.map(r => r.id).join(','),
                attachment,
                attachmentPaths,
            };
            resubmitDesignChange(data)
                .then(() => {
                    this.$close(this.$route.path, "/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding: 24px 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
